import styled from "styled-components"
import { Container, Grid } from "@mui/material"
import CustomLink from "../../components/custom-link/custom-link.component"

export const Background = styled(Container)`
  background-color: #ffffff;
`

export const ButtonWrapper = styled(Container)`
  text-align: right;

  a {
    text-decoration: none;

    button {
      text-transform: unset;
      color: #ffffff;
      background-color: #d21e1e;
      font-size: ${({ theme }) => theme.typography.pxToRem(18)};
      padding: 0.5em 1.5em;
      border-radius: unset;

      &:hover {
        background-color: #000000;
        transition: background-color 0.6s ease;
      }
    }
  }
`

export const Columns = styled(Grid)`
  padding: 4em 15px;
`

export const Wrapper = styled(CustomLink)`
  cursor: pointer;
  padding-bottom: 2em;

  a {
    cursor: pointer;
    text-decoration: none !important;
  }

  .wrapper {
    margin-bottom: 2em;

    .gatsby-image-wrapper {
      ${({ theme }) => theme.breakpoints.up("sm")} {
        max-height: 450px;
        min-height: 450px;
      }
    }
  }

  .title {
    font-size: ${({ theme }) => theme.typography.pxToRem(24)};
    margin-top: 0;
    margin-bottom: 0.25em;
    line-height: 27px;
  }

  .text {
    font-size: ${({ theme }) => theme.typography.pxToRem(16)};
    margin-top: 0;
    margin-bottom: 0.5em;

    p {
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  .date {
    font-size: ${({ theme }) => theme.typography.pxToRem(14)};
    margin-top: 0;
    opacity: 0.5;
  }
`
